import { Search } from "lucide-react";

import { TranslatedText } from "@/components/common/text";

export const ChatThinking = () => {
    return (
        <div className="flex items-center gap-2 text-cm-p-text-secondary text-sm">
            <Search size={16} />
            <TranslatedText>Thinking...</TranslatedText>
        </div>
    );
};
